export default {
  root: {
    height: 'auto',
    position: 'fixed',
    width: 'calc(100% - 260px - (5vw * 2))',
    borderRadius: 10,
    backgroundColor: 'rgb(254,254,254)',
    padding: '10px 10px',
    zIndex: 11,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    bottom: '4vh',
    '& > *': {
      display: 'inline-block',
      verticalAlign: 'top',
    },
    '& > * > *': {
      marginRight: '2vw',
    },
    '& > * > h5': {
      borderBottom: '1px solid rgba(0,0,0,0.4)',
    },
  },
  alignHorizontal: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: 0,
    },
  },
  inputQuantity: {
    width: 70,
  },
};
